import axios from '../../axios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/system/sysDept/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/system/sysDept/delete',
        method: 'post',
        data
    })
}
// 列表
export const list = (data) => {
    return axios({
        url: '/system/sysDept/list',
        method: 'post',
        data
    })
}
// 新增
export const edit = (data) => {
  return axios({
    url: '/system/sysDept/edit',
    method: 'post',
    data
  })
}
// 查看,编辑
export const view = (data) => {
  return axios({
    url: '/system/sysDept/view',
    method: 'post',
    data
  })
};




// WEBPACK FOOTER //
// ./src/http/moudules/sys/dept.js